// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"list_ahMH3"};